module.exports = __webpack_public_path__ + "img/yjc-icon.cbd0d370.png";